<template>
  <div class="card mb-3">
    <div class="card-header cursor-pointer d-flex justify-content-between align-items-center py-1" @click="toggleShowBody">
      <span class="font-weight-bold">Detalhes do Pedido</span>
      <i :class="'fa fa-lg ' + (showBody ? 'fa-caret-down' : 'fa-caret-up')"></i>
    </div>

    <div v-if="showBody" class="card-body py-2">
      <div class="row">
        <div class="col-lg-6 col-12">
          <div v-if="refLabel">
            <b>Transação: </b>{{ refLabel }}
          </div>
          <div v-if="order.company && order.company.ref">
            <b>Empresa: </b>{{ order.company.ref }}
          </div>
          <div v-if="order.fiscalOperation && order.fiscalOperation.description">
            <b>Operação: </b>{{ (order.fiscalOperation.ref || '0') + ' - ' + order.fiscalOperation.description }}
          </div>
          <small class="text-muted">
            <b>UUID: </b>{{ order.id }}
          </small>
        </div>

        <div class="col-lg-6 col-12">
          <div v-if="order.customer && order.customer.person && order.customer.person.name">
            <b>{{ customerLabel }}: </b>{{ order.customer.person.name }}
          </div>
          <div v-if="order.transporter && order.transporter.person && order.transporter.person.name">
            <b>Transportadora: </b>{{ order.transporter.person.name }}
          </div>
          <div v-if="order.stockLocale && order.stockLocale.name">
            <b>Armazém: </b>{{ order.stockLocale.name }}
          </div>
        </div>

        <order-observation
          :order="order"
        ></order-observation>
      </div>
    </div>
  </div>
</template>

<script>
  import shared from '@/shared/shared';
  import OrderObservation from '@/components/order-observation'

  const STORAGE_KEY = 'order-infos/showBody';

  export default {
    name: 'order-infos',

    components: {
      OrderObservation
    },

    props: {
      order: {
        type: Object
      }
    },

    data() {
      return {
        showBody: false
      }
    },

    mounted() {
      const saved = shared.getLocalStorageString(STORAGE_KEY);
      if (saved !== null && saved !== '') {
        this.showBody = saved === 'true';
      }
    },

    computed: {
      refLabel() {
        if (this.order.refLabel) {
          return this.order.refLabel;
        }
        if (this.order.ref && this.order.ref.length) {
          return this.order.ref.replace(/\D/g, '');
        }
        return null;
      },

      customerLabel() {
        if (this.order.fiscalOperation && this.order.fiscalOperation.type === 'ENT') {
          return 'Origem';
        }
        if (this.order.fiscalOperation && this.order.fiscalOperation.type === 'SAI') {
          return 'Destino';
        }
        return 'Cliente';
      }
    },

    methods: {
      toggleShowBody() {
        this.showBody = !this.showBody;
        shared.setLocalStorageString(STORAGE_KEY, this.showBody);
      }
    }
  }
</script>

<style scoped>

</style>
